import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next/src';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { DraggableDialog } from '@hobs/components/Dialog';
import Textarea from '@hobs/components/Textarea';
import { Formik, Form, Field } from 'formik';
import { RaisedButton, GhostButton } from '@hobs/components/Buttons';
import Alert from '@hobs/components/Alert';

import './ActionWithCommentDialog.scss';

const defaultState = {
  error: null
};

class ActionWithCommentDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = defaultState;

    const { t, isCommentRequired } = props;

    if (isCommentRequired) {
      this.schema = Yup.object().shape({
        comment: Yup.string()
          .max(1500, t('Comment cannot be longer than 1500 symbols'))
          .required(t('Comment is required'))
          .nullable()
      });
    } else {
      this.schema = Yup.object().shape({
        comment: Yup.string()
          .max(1500, t('Comment cannot be longer than 1500 symbols'))
          .nullable()
      });
    }
  }

  onDialogClose = () => {
    const { reload, closeDialog } = this.props;

    if (reload) {
      reload();
    }

    closeDialog();
  };

  onDialogClosed = () => {
    this.resetState();
  };

  submitConfirmReject = (values, { setSubmitting, setErrors }) => {
    const { onSubmit } = this.props;

    onSubmit(
      values,
      { setSubmitting, setErrors },
      this.setError,
      this.onDialogClose
    );
  };

  setError = message => {
    this.setState({ error: message });
  };

  resetState() {
    this.setState(defaultState);
  }

  render() {
    const {
      t,
      isDialogOpen,
      cancelText,
      confirmText,
      commentLabel,
      title
    } = this.props;
    const { error } = this.state;
    return (
      <DraggableDialog
        title={title ? title : t('Reject additional request')}
        isOpen={isDialogOpen}
        onClose={this.onDialogClose}
        onClosed={this.onDialogClosed}
        onOpening={this.onDialogOpening}
        className="response"
      >
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={this.schema}
          enableReinitialize={true}
          initialValues={{
            comment: null
          }}
          onSubmit={this.submitConfirmReject}
        >
          {({ setFieldValue, isSubmitting }) => (
            <Form>
              {error && <Alert type="error">{error}</Alert>}
              <div className="response--dialog">
                <Field
                  name="comment"
                  component={Textarea}
                  noMargin
                  setFieldValue={setFieldValue}
                  label={commentLabel ? commentLabel : t('Comment')}
                />
                <div className="response--dialog--button">
                  <GhostButton
                    onClick={() => {
                      this.onDialogClose();
                    }}
                  >
                    {cancelText ? cancelText : t('Cancel')}
                  </GhostButton>
                  <RaisedButton type="submit" disabled={isSubmitting}>
                    {confirmText ? confirmText : t('Reject')}
                  </RaisedButton>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </DraggableDialog>
    );
  }
}

ActionWithCommentDialog.propTypes = {
  t: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  reload: PropTypes.func,
  isDialogOpen: PropTypes.bool,
  closeDialog: PropTypes.func,
  onSubmit: PropTypes.func,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  commentLabel: PropTypes.string,
  title: PropTypes.string,
  isCommentRequired: PropTypes.bool
};

ActionWithCommentDialog.defaultProps = {
  isCommentRequired: true
};

export default withRouter(withTranslation()(ActionWithCommentDialog));
